var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"business-map-wrapper"},[_c('div',{ref:"map",staticClass:"map"}),_vm._v(" "),_c('div',{staticClass:"info-window-wrapper"},[_c('info-window-content',{ref:"infoWindowContent",attrs:{"business":_vm.business,"show-link":false}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }